import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { NgxSpinnerService } from 'ngx-spinner';

import { FieldMapItem, NotificationService } from 'beyond-util';

import { BackendService } from '../../services/backend.service';
import { FormCode } from '../../enums/form-code.enum';
import { FormName } from '../../enums/form-name.enum';
import { EndpointTypes } from '../../enums/enpoint-types.enum';
import { MontazaService } from '../../services/montaza.service';
import { MONTAZA_SACUVAJ_EMISIJU } from '../../constants/tooltip-messages';

@Component({
  selector: 'app-emisija-details',
  templateUrl: './emisija-details.component.html',
})
export class EmisijaDetailsComponent implements OnInit, OnDestroy {
  @Input() programFieldSettings: FieldMapItem;
  @Input() vremeFieldSettings: FieldMapItem;
  @Input() cenaFieldSettings: FieldMapItem;
  @Input() programi: any;

  @Input('selectedEmisija')
  get selectedEmisija(): any {
    return this.emisija;
  }

  set selectedEmisija(value: any) {
    if (value) {
      this.emisija = { ...value };
      this._originEmisija = { ...value };
      this.emisija.ProgramId = this._montazaService.programId;
    }
  }

  @Input('rezervacije')
  get rezervacije(): any {
    return this._rezervacije;
  }

  set rezervacije(value: any) {
    if (value) {
      this._rezervacije = [...value];
    }
  }

  @Output() updateEmisija: EventEmitter<any> = new EventEmitter();

  get isEmisijaMontirana(): boolean {
    return this.emisija && this.emisija.Status === 2;
  }

  public emisija: any;
  public tooltipOptions = {
    placement: 'top',
    'show-delay': '500',
    theme: 'light',
  };

  private _originEmisija: any;
  private _oldProgramId;
  private _oldVremeEmitovanja;
  private _rezervacije;

  public tooltips = {
    MONTAZA_SACUVAJ_EMISIJU,
  };

  private _subscriptions: Subscription[] = [];

  constructor(
    private _backendService: BackendService,
    private _montazaService: MontazaService,
    private _notificationService: NotificationService,
    private _spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this._oldProgramId = this.emisija.ProgramId;
    this._oldVremeEmitovanja = this.emisija.VremeEmitovanja;
    this.cenaFieldSettings.editable = false;
    this.emisija.ProgramNaziv = this.programi.find(
      p => p.Id === this.emisija.ProgramId
    ).Naziv;
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  onSelectedProgramChange(event) {
    if (event.value) {
      this.emisija.ProgramId = event.value;
      this.emisija.ProgramNaziv = this.programi.find(
        p => p.Id === event.value
      ).Naziv;
    }
  }

  updateVremeEmitovanja(event) {
    this.emisija.VremeEmitovanja = event.value;
  }

  updateCenaPoSek(event) {
    this.emisija.OsnovnaCenaSek = event.value;
  }

  updateCenaPoCPP(event) {
    this.emisija.OsnovnaCenaCPP = event.value;
  }

  saveEmisija() {
    this._spinner.show();

    const entity = {
      Sadrzaj: this._rezervacije,

      DatumMontaze: this._montazaService.datum,
      OriginMontazaId: this._montazaService.montaza.Id,
      OriginEmisijaRasporedId: this._originEmisija.Id,
      OriginEmisijaRasporedIdGuid: this._originEmisija.EmisijaRasporedId,
      OriginEmisijaIdGuid: this._originEmisija.EmisijaId,
      OriginProgramId: this._originEmisija.ProgramId,
      OriginDatumEmitovanja: this._originEmisija.DatumEmitovanja,

      TargetDatumMontaze: this.emisija.DatumEmitovanja,
      TargetDatumEmitovanja: this.emisija.DatumEmitovanja,
      TargetEmisijaNaziv: this.emisija.EmisijaNaziv,
      TargetEmisijaId: this.emisija.EmisijaId,
      TargetEmisijaSifra: this.emisija.EmisijaSifra,
      TargetEmisijaRasporedId: this.emisija.EmisijaRasporedId,
      TargetVremeEmitovanja: this.emisija.VremeEmitovanja,
      TargetTrajanje: this.emisija.Trajanje,
      TargetOsnovnaCenaSek: this.emisija.OsnovnaCenaSek,
      TargetOsnovnaCenaCPP: this.emisija.OsnovnaCenaCPP,
      TargetProgramId: this.emisija.ProgramId,
      TargetProgramNaziv: this.emisija.ProgramNaziv,
    };

    const payload = this._backendService.getRequestPayload(
      FormCode.MSMON_UER,
      FormName.Montaza,
      EndpointTypes.PutEntity,
      null,
      entity
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          this._spinner.hide();

          if (this._montazaService.hasError(response)) {
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          const isProgramChanged = this.emisija.ProgramId !== this._oldProgramId;
          const isVremeChanged = this.emisija.VremeEmitovanja !== this._oldVremeEmitovanja;
            
          const message = isProgramChanged
            ? `Emisija uspešno sačuvana na ${this.emisija.ProgramNaziv}.`
            : 'Emisija uspešno sačuvana.';
          const updateObject = {
            emisija: this.emisija,
            isProgramChanged: isProgramChanged,
            isVremeChanged: isVremeChanged
          };

          this.updateEmisija.emit(updateObject);
          this._notificationService.openNoty(message);
        })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/emisija-details/emisija-details.component.ts